// extracted by mini-css-extract-plugin
export default {"CartSummary__list":"CartSummary-styles__CartSummary__list__u1xw2"};